import React from 'react';
import { BaseIcon } from '../../base/BaseIcon';
import { IconProps } from '../../types';

export const TimeToggleIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M12.75 4.54V3.6H15C15.99 3.6 16.8 2.79 16.8 1.8C16.8 0.81 15.99 0 15 0H9.00001C8.01001 0 7.20001 0.81 7.20001 1.8C7.20001 2.79 8.01001 3.6 9.00001 3.6H11.25V4.54C6.47001 4.92 2.70001 8.93 2.70001 13.8C2.70001 18.93 6.87001 23.1 12 23.1C17.13 23.1 21.3 18.93 21.3 13.8C21.3 8.67 17.53 4.92 12.75 4.54ZM12 21.6C7.69001 21.6 4.20001 18.11 4.20001 13.8C4.20001 9.49 7.69001 6 12 6C16.31 6 19.8 9.49 19.8 13.8C19.8 18.11 16.31 21.6 12 21.6Z"
        fill={color}
      />
      <path
        d="M16.8 13.05H12.75V9C12.75 8.59 12.41 8.25 12 8.25C11.59 8.25 11.25 8.59 11.25 9V13.8C11.25 14.21 11.59 14.55 12 14.55H16.8C17.21 14.55 17.55 14.21 17.55 13.8C17.55 13.39 17.21 13.05 16.8 13.05Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

TimeToggleIcon.displayName = 'TimeToggleIcon';
